import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {ProjectsService} from '../../../projects/data/projects.service';
import {TranslateService} from '../../../../services/multilingual/translate.service';
import {SanitizationService} from 'src/app/services/sanitization/sanitization.service';
import { DashboardDateRange } from '../../period-pickers/dashboard-date-range-filter/dashboard-date-range-filter.component';
import { DashboardWidgetComponent, DashboardWidgetInstance } from '../../../../components/JBM/Dashboard/models/dashboard-widget.types';
import * as echarts from 'echarts';

const GRAPH_WIDTH = 125;
const GRAPH_HEIGHT = 125;

@Component({
  selector: 'widget-projects',
  templateUrl: './widget-projects.component.html',
  styleUrls: ['./widget-projects.component.scss']
})
export class WidgetProjectsComponent implements DashboardWidgetComponent, OnInit, OnChanges, OnDestroy {
  title: string = 'Projectoverzicht';
  icon: string = 'fa-cogs';
  recentProjects=[];
  data=[];
  chart=null

  @Input() config!: DashboardWidgetInstance;
  @ViewChild('chart', { static: true }) chartElement: ElementRef;

  countTitle: string=this.TranslateService.GetTranslation('ui.quantity') + ' ' +
      this.TranslateService.GetTranslation('entity.projects').toLowerCase() + '\n' +
      this.TranslateService.GetTranslation('ui.per').toLowerCase() + ' ' +
      this.TranslateService.GetTranslation('project.state').toLowerCase()
  countSerieName: string=this.TranslateService.GetTranslation('ui.quantity') + ' ' +
      this.TranslateService.GetTranslation('entity.projects').toLowerCase()

  amountTitle: string=this.TranslateService.GetTranslation('concrete.mortal') + ' ' +
      this.TranslateService.GetTranslation('order.amounts').toLowerCase() + '\n' +
      this.TranslateService.GetTranslation('ui.per').toLowerCase() + ' ' +
      this.TranslateService.GetTranslation('project.state').toLowerCase()
  amountSerieName: string=this.TranslateService.GetTranslation('concrete.mortal') + ' ' +
      this.TranslateService.GetTranslation('order.amount').toLowerCase()

  plantId: number=0;
  dateRange: DashboardDateRange | null = null;

  constructor(
      private Router: Router,
      private TranslateService: TranslateService,
      private ProjectsService: ProjectsService,
      private SanitizationService: SanitizationService
  ) {}

  ngOnInit(): void {
    this.chart=echarts.init(this.chartElement.nativeElement, null, {
      renderer: 'canvas',
      useDirtyRect: false,
      devicePixelRatio: 1,
      height: GRAPH_HEIGHT,
      width: GRAPH_WIDTH
    });
    if(this.data.length)
      this.setGraphOptions();
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.config) {
      this.plantId = Number(this.config?.settings?.plantId ?? 0);
      this.dateRange = this.config?.context?.dateRange as DashboardDateRange ?? null;
      console.log('Projectwidget dashboardperiode:', this.dateRange);
    }
    this.getData();
    this.getRecentProjects();
  }

  getData() {
    if(!this.dateRange)
      return;

    this.ProjectsService.getDashboardStateVsCount(
      this.plantId,
      this.dateRange.fromUnixTime / 1000,
      this.dateRange.toUnixTime / 1000
    ).subscribe(
      (data: any)=> {
        this.data = data.data
        this.sanitizeData();
        this.setGraphOptions();
      }, (error: any)=>console.error(error))
  }
  showProjects(projectState: number) {
    this.Router.navigate(['/projects'], {
      queryParams: { projectstate: projectState }
    });
  }
  getRecentProjects() {
    this.ProjectsService.getDashboardRecent().subscribe(
        (data: any)=>this.recentProjects=data.data,
        (error: any)=>console.error(error)
    )
  }
  sanitizeData() {
    for (let info of this.data) {
      info.projectsStr = info.projects ? info.projects : '';
      info.totalAmountStr = info.totalAmount ? this.SanitizationService.amountFloatToStr(info.totalAmount) + 'm³' : '';
      info.totalPriceStr = info.totalPrice ? '€' + this.SanitizationService.amountFloatToStr(info.totalPrice) : '';
    }
  }
  setGraphOptions() {
    if(!this.chart)
      return;

    const totalProjects = this.data.reduce(
      (total: number, item: any) => total + Number(item.projects || 0),
      0
    );
    let option = {
      tooltip: {
        trigger: 'item',
        position: ['0%', '105%'],
        extraCssText: 'z-index: 1000;',
        textStyle: {
          fontSize: 10,
        }
      },
      graphic: [
        {
          type: 'text',
          left: 'center',
          top: 'middle',
          style: {
            text: totalProjects.toString(),
            fill: '#333',
            fontSize: 18,
            fontWeight: 600,
            textAlign: 'center',
            textVerticalAlign: 'middle'
          }
        }
      ],
      series: [
        {
          name: this.countSerieName,
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['40%', '70%'],
          data: this.data.map((item: any) => ({
            value: item.projects,
            name: item.description,
            itemStyle: { color: item.color }
          })),
          label: {
            show: false,
            formatter: '{b}: {c}',
            fontSize: 8,
            color: '#000'
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    this.chart.resize({
      width: GRAPH_WIDTH,
      height: GRAPH_HEIGHT
    });
    // @ts-ignore
    option && this.chart.setOption(option);
  }

  ngOnDestroy(): void {
    this.chart?.dispose();
  }
}
